module.exports = "img/singer.jpg";